import IC_MINI_WIN from "../assets/common/ic_mini_win.svg?react";
import IC_CLOSE_WIN from "../assets/common/ic_close_win.svg?react";
import IC_FULL_WIN from "../assets/common/ic_fullScreen.svg?react";
import IC_SHRINK_WIN from "../assets/common/ic_shrink_win.svg?react";
import { setClose, setHide, setMaxsize } from "@/utils/window";
import "./Header.css";
import appStore from "@/store/app.store";
import User from "@/sections/User";
import { message } from "antd";
import HeaderVoice from "./HeaderVoice";
import useChecBeforeExit from "@/layout/checkBeforeExit";
import HeaderCollaboration from "./HeaderCollaboration";
import HeaderUpdateTip from "./HeaderUpdateTip";
import { SURPORT_MODEL_ID } from "@/constants";

const isWindows = navigator.platform.indexOf("Win") !== -1;

function Header(prop: { showInfo: boolean, showMaxBtn: boolean }) {

  const isSupportMaximize = appStore((state) => state.isSupportMaximize);
  const isMaximize = appStore((state) => state.isMaximize);
  const asrModelId = appStore((state) => state.asrModelId);

  const isHomePage = location.pathname.indexOf("home") !== -1;
  const isCollaborationPage = location.pathname.indexOf("collaboration") !== -1;
  const getHeaderStyle: () => string = () => {
    if (isWindows) {
      return 'pt-3';
    }
    if (isHomePage) {
      return 'pt-2';
    }
    if (isCollaborationPage) {
      return 'pt-0';
    }
    return 'pt-7';
  }


  const handleClose = useChecBeforeExit(() => {
    // 在录制页禁止退出，弹警告
    if (location.pathname === "/record") {
      message.warning("会议记录录制中，请先结束录制再关闭应用");
      return;
    }
    setClose();
  });


  return (
    <header className={`flex justify-end drag items-center ${getHeaderStyle()}`}>
      {isHomePage && <HeaderUpdateTip />}
      {isHomePage && <div id="home-search" className="flex items-center no_drag"></div>}
      {isHomePage && asrModelId === SURPORT_MODEL_ID.TencentLarge && <HeaderVoice />}
      {isCollaborationPage && <HeaderCollaboration />}
      {prop.showInfo && (
        <div className="p-r-6 flex items-center cursor-pointer relative no_drag">
          <User />
        </div>
      )}
      {isWindows && (
        <div className="flex items-center p-x-6">
          <IC_MINI_WIN className="w-4 h-4 m-r-2.5 cursor-pointer no_drag" onClick={setHide} />
          {prop.showMaxBtn &&
            isSupportMaximize &&
            (isMaximize ? (
              <IC_SHRINK_WIN
                className="w-4 h-4 m-r-2.5 cursor-pointer no_drag"
                onClick={() => {
                  setMaxsize(false);
                }}
              />
            ) : (
              <IC_FULL_WIN
                className="w-4 h-4 m-r-2.5 cursor-pointer no_drag"
                onClick={() => {
                  setMaxsize(true);
                }}
              />
            ))}
          <IC_CLOSE_WIN className="w-4 h-4 cursor-pointer no_drag" onClick={handleClose} />
        </div>
      )}
    </header>
  );
}

export default Header;
